var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container has-background-white-ter"},[_c('section',{staticClass:"section is-primary pb-1"},[_c('ve-table',{attrs:{"fixed-header":true,"columns":_vm.getDataTable.headings,"table-data":_vm.getDataTable.students}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }